import { render, staticRenderFns } from "./StoreDataDashboard.vue?vue&type=template&id=6f4e466a&scoped=true"
import script from "./StoreDataDashboard.vue?vue&type=script&lang=js"
export * from "./StoreDataDashboard.vue?vue&type=script&lang=js"
import style0 from "./StoreDataDashboard.vue?vue&type=style&index=0&id=6f4e466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e466a",
  null
  
)

export default component.exports